var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCancelSm = function SvgCancelSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cancelSm_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1A1E2C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.97 7.842a.64.64 0 0 1 .92 0l7.364 7.532a.676.676 0 0 1 0 .941.64.64 0 0 1-.92 0L7.969 8.784a.676.676 0 0 1 0-.942Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.254 7.842a.676.676 0 0 1 0 .942L8.89 16.315a.64.64 0 0 1-.92 0 .676.676 0 0 1 0-.941l7.364-7.532a.64.64 0 0 1 .92 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cancelSm_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCancelSm;